import {
  Document,
  BLOCKS,
  INLINES,
  Inline,
  Text as TextType,
} from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { Link } from '@awaze/design-system.components.link'
import { Text, TextProps } from '@awaze/design-system.components.text'
import { pxToRems } from '@awaze/design-system.utils.react'
import styled from 'styled-components'
import { JSX } from 'react'

interface RichTextProps {
  content?: Document
  textColor?: TextProps['color']
  className?: string
}

const Container = styled.div`
  p + p {
    margin-top: ${pxToRems(12)};
  }
`

export default function RichText({
  content,
  textColor,
  className,
}: RichTextProps): JSX.Element {
  return (
    <Container className={className}>
      {documentToReactComponents(content, {
        renderText: (text) => {
          return text.split('\n').reduce((children, textSegment, index) => {
            return [...children, index > 0 && <br key={index} />, textSegment]
          }, [])
        },
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => {
            return (
              <Text as="p" sizes={300} color={textColor}>
                {children}
              </Text>
            )
          },
          [BLOCKS.UL_LIST]: (_, children) => {
            return (
              <ul
                style={{
                  margin: `${pxToRems(8)} 0 ${pxToRems(8)} ${pxToRems(20)}`,
                }}
              >
                {children}
              </ul>
            )
          },
          [INLINES.HYPERLINK]: (node: Inline) => {
            let urlText = (node.content[0] as TextType)?.value
            const noFollow = urlText?.includes('{{nofollow}}')
            urlText = urlText?.replace('{{nofollow}}', '')

            return (
              urlText && (
                <Link
                  href={node.data.uri}
                  {...(noFollow ? { rel: 'nofollow' } : {})}
                >
                  {urlText}
                </Link>
              )
            )
          },
        },
      })}
    </Container>
  )
}
